import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { filtrarGrupos, useListFilters } from '../core/ListFiltersProvider'
import { GrupoList } from '../core/_models'
import { GruposColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const GruposTable = () => {
  const { responseSemPaginacao, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => GruposColumns(t), [t])

  const grupos = useMemo(
    () => filtrarGrupos(responseSemPaginacao, filters),
    [responseSemPaginacao, filters]
  )

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum perfil encontrado para “${filters.nome.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum perfil cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro perfil.'
    />
  )

  return (
    <CustomTable<GrupoList>
      id='kt_table_grupos'
      ariaLabel={t('grupo.plural')}
      itemLabel={{ singular: t('grupo.label.lowercase'), plural: t('grupo.plural.lowercase') }}
      data={grupos}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      notPaginated
    />
  )
}
